import { render, staticRenderFns } from "./CopiarMatriz.vue?vue&type=template&id=74b758e6&scoped=true&"
import script from "./CopiarMatriz.vue?vue&type=script&lang=js&"
export * from "./CopiarMatriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b758e6",
  null
  
)

export default component.exports